<div *ngIf="application">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>assignment</mat-icon>
      {{
        application.id ? application.name : "Create new application"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ application.id ? "save" : "add" }}</mat-icon>
        {{ application.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="application.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Application Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="application.name"
                required
                maxlength="200"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Application Tag</th>
            <td>
              <div class="hbox">
                <input style="flex: 1;" #applicationTag="ngModel" [(ngModel)]="application.applicationTagName" placeholder="Application Tag" id="applicationTagName" name="applicationTagName" disabled />
                <div class="margin-auto" *ngIf="application.applicationTagName && application.applicationTagName !== 'undefined' && application.applicationTagName !== 'Unknown tag'">
                  <a class="margin-auto" routerLink="/applicationTags/{{ application.applicationTagId }}" matTooltip="Jump to {{ application.applicationTagName }}" ><mat-icon class="icon-small">call_made</mat-icon></a>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>Business Criticality</th>
            <td>
              <input
                [(ngModel)]="application.businessCriticality"
                maxlength="50"
                id="businessCriticality"
                name="businessCriticality"
              />
            </td>
          </tr>
          <tr>
            <th>Operational Status</th>
            <td>
              <input
                [(ngModel)]="application.operationalStatus"
                maxlength="50"
                id="operationalStatus"
                name="operationalStatus"
              />
            </td>
          </tr>
          <tr>
            <th>Asset Tag</th>
            <td>
              <input
                [(ngModel)]="application.assetTag"
                maxlength="50"
                id="assetTag"
                name="assetTag"
              />
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="application.description"
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th>Business Owner</th>
            <td>
              <micro-select-combo
                    [placeholder]="'Business Owner'"
                    routerBase="contacts"
                    [(id)]="application.businessOwnerId"
                    (idChange)="onChange($event)"
                    [options]="contactOptions"
                    [required]="false"
                    [loading]="isLoading"
              ></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>Business Department</th>
            <td>
              <micro-select-combo
                    [placeholder]="'Business Department'"
                    [(id)]="application.businessDepartmentId"
                    (idChange)="onChange($event)"
                    [options]="departmentOptions"
                    [required]="false"
                    [loading]="isLoading"
                    [jump]="false"
              ></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>IT Owner</th>
            <td>
              <micro-select-combo
                    [placeholder]="'IT Owner'"
                    routerBase="contacts"
                    [(id)]="application.itOwnerId"
                    (idChange)="onChange($event)"
                    [options]="contactOptions"
                    [required]="false"
                    [loading]="isLoading"
              ></micro-select-combo>
            </td>
          </tr>
          <tr>
            <th>IT Department</th>
            <td>
              <micro-select-combo
                    [placeholder]="'IT Department'"
                    [(id)]="application.itDepartmentId"
                    (idChange)="onChange($event)"
                    [options]="departmentOptions"
                    [required]="false"
                    [loading]="isLoading"
                    [jump]="false"
              ></micro-select-combo>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
